<template>
  <div class="position-relative" v-click-outside="clickOutside">
    <div
      class="d-flex justify-content-end align-items-center color-show w-100 border rounded"
      :style="{ backgroundColor: formColor }"
    >
      <b-button @click="showColorPicker = !showColorPicker" variant="light"
        ><img
          width="15"
          height="15"
          :src="
            isStandalone() ? '/icons/loupe.svg' : '/desktop/icons/loupe.svg'
          "
      /></b-button>
    </div>
    <div
      v-if="showColorPicker"
      class="position-absolute color-picker-container"
      style="z-index: 3;"
    >
      <twitter-picker
        v-model="formColor"
        triangle="top-right"
        :defaultColors="defaultColors"
      />
    </div>
  </div>
</template>

<script>
import { Twitter as TwitterPicker } from "vue-color";

export default {
  name: "ColorPicker",
  components: { TwitterPicker },
  props: ["value"],
  data() {
    return {
      showColorPicker: false,
      defaultColors: [
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#808080",
        "#CCCCCC",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
      ]
    };
  },
  methods: {
    clickOutside() {
      this.showColorPicker = false;
    }
  },
  computed: {
    formColor: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (newValue && newValue.hex) this.$emit("input", newValue.hex);
        this.showColorPicker = false;
      }
    }
  }
};
</script>

<style scoped>
.color-picker-container {
  right: 0;
}
</style>
